import { render, staticRenderFns } from "./lineupData.vue?vue&type=template&id=2d0ac2d7&scoped=true"
var script = {}
import style0 from "./lineupData.vue?vue&type=style&index=0&id=2d0ac2d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d0ac2d7",
  null
  
)

export default component.exports